import CalendarBigIcon from "./CalendarBigIcon";
import CalendarIcon from "./CalendarIcon";
import ClipboardIcon from "./ClipboardIcon";
import ConfettieBg from "./ConfettieBg";
import DesktopSyncIcon from "./DesktopSyncIcon";
import DollarIcon from "./DollarIcon";
import DownloadIcon from "./DownloadIcon";
import EggIcon from "./EggIcon";
import GCalIcon from "./GCalIcon";
import HealthBigIcon from "./HealthBigIcon";
import IntegrationsIconGradient from "./IntegrationsIconGradient";
import IntegrationsIconWhite from "./IntegrationsIconWhite";
import LightBulbIcon from "./LightBulbIcon";
import LocationIcon from "./LocationIcon";
import MacIcon from "./MacIcon";
import MappingsBigIcon from "./MappingsBigIcon";
import MappingsDoneBigIcon from "./MappingsDoneBigIcon";
import MetricsIcon from "./MetricsIcon";
import NotificationsIcon from "./NotificationsIcon";
import PersonalIcon from "./PersonalIcon";
import SlackIcon from "./SlackIcon";
import TrendsIcon from "./TrendsIcon";
import WandGradientIcon from "./WandGradientIcon";
import WandIcon from "./WandIcon";
import WindowsIcon from "./WindowsIcon";
import WorkoutsIcon from "./WorkoutsIcon";
import HistoryIcon from "./HistoryIcon";
import EditWhitePencil from "./EditWhitePencil";
import ResumeTrackingIcon from "./ResumeTrackingIcon";
import HiddenIcon from "./HiddenIcon";
import RulesIcon from "./RulesIcon";
import DogWalkingIcon from "./DogWalkingIcon";
import NativeCalendarIcon from "./NativeCalendarIcon";
import GoogleIcon from "./GoogleIcon";
import OutlookIcon from "./OutlookIcon";
import HealthEmptyIcon from './HealthEmptyIcon';

const IntegrationIcons = {
  CalendarBigIcon,
  CalendarIcon,
  ClipboardIcon,
  ConfettieBg,
  DesktopSyncIcon,
  DollarIcon,
  DogWalkingIcon,
  DownloadIcon,
  EggIcon,
  EditWhitePencil,
  NativeCalendarIcon,
  GoogleIcon,
  GCalIcon,
  HealthBigIcon,
  IntegrationsIconGradient,
  IntegrationsIconWhite,
  LightBulbIcon,
  LocationIcon,
  HiddenIcon,
  HistoryIcon,
  MacIcon,
  OutlookIcon,
  MappingsBigIcon,
  MappingsDoneBigIcon,
  MetricsIcon,
  NotificationsIcon,
  PersonalIcon,
  RulesIcon,
  SlackIcon,
  TrendsIcon,
  WandGradientIcon,
  WandIcon,
  WindowsIcon,
  WorkoutsIcon,
  ResumeTrackingIcon,
  HealthEmptyIcon
};

export default IntegrationIcons;
